import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getProductsForInventory = unaryRpc({
  name: "getProductsForInventory" as const,
  input: z.object({}),
  output: z.object({
    products: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
        defaultVariantId: z.string(),
        sku: z.string(),
      }),
    ),
  }),
});
